"use client";

import { useMemo } from "react";
import { useSelector } from "react-redux";
import { iBrand } from "@sdk/brands/brand-model";
import { LoadAllBrands } from "@/store/modules/brands/brands.helpers";
import {
  selectAllBrandsQuery,
  selectBrandById,
} from "@/store/modules/brands/brands.selectors";
import { useQueryWithStore } from "@/store/store.hooks";

export function useBrands() {
  const query = useQueryWithStore(
    selectAllBrandsQuery,
    LoadAllBrands,
    []
  );

  const brands = useMemo(
    () => ((query.state?.list ?? []) as iBrand[]).filter((brand) => !!brand?.id),
    [query.state?.list]
  );

  const activeBrands = useMemo(
    () => brands.filter((brand) => !brand.isDisabled),
    [brands]
  );

  return {
    ...query,
    brands,
    activeBrands,
  };
}

export function useBrandById(brandId?: string) {
  const selector = useMemo(
    () => selectBrandById(brandId ?? ""),
    [brandId]
  );
  return useSelector(selector);
}
